export const LOGIN_FORM = 'LOGIN_FORM';
export const SUBDOMAIN_FORM = 'SUBDOMAIN_FORM';

export const DEFAULT_AUTH = 'default';
export const DIALPAD_AUTH = 'dialpad';
export const DIALPAD_SANDBOX_AUTH = 'dialpad_sandbox';

export const OAUTH_CSRF_COOKIE = 'OAUTH_CSRF_TOKEN';
